const styles = (theme) => ({
  contactOurBranch: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(9),
      paddingBottom: theme.spacing(9),
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
    '& .branchWrapper': {
      marginTop: theme.spacing(10),
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(9),
      },
      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(8),
      },
    },
    '& .branchCard': {
      height: 724,
      borderRadius: 6,
      boxShadow: '0 23px 42px 0 rgba(106, 118, 154, 0.15)',
      backgroundColor: '#ffffff',
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
      '& .bannerImg': {
        height: 350,
        width: '100%',
        objectFit:'cover',
      },
      '& .branchCardData': {
        padding: theme.spacing(3.5, 3.5),
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('sm')]: {
          padding: theme.spacing(2),
        },
        '& .country': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          '& img': {
            height: 33,
          },
          '& .countryName': {
            color: '#4c4c78',
            fontWeight: 700,
            marginLeft: theme.spacing(2),
          },
        },
        '& .infoTitle': {
          color: '#4c4c78',
          margin: theme.spacing(2, 0),
        },
        '& .infoData': {
          color: '#4c4c78',
          fontWeight: 500,
          margin: theme.spacing(0.5, 0),
          fontFamily: 'Raleway,Assistant,sans-serif',
        },
      },
    },
  },
})
export default styles